// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Drawer_drawer__rp9rX {
  height: 100%;
  overflow: auto;
  position: fixed;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  transition: transform var(--transition-speed) ease;
  z-index: 100000;
  width: 100%;
  max-width: 320px;
}
.Drawer_drawer__rp9rX.Drawer_left__fpsIh {
  top: 0;
  left: 0;
  transform: translateX(-100%);
}
.Drawer_drawer__rp9rX.Drawer_right__e31w9 {
  top: 0;
  right: 0;
  transform: translateX(100%);
}

.Drawer_backdrop__\\+Jv48 {
  visibility: hidden;
  opacity: 0;
  background: rgba(0, 0, 0, 0.5);
  transition: opacity var(--transition-speed) ease, visibility var(--transition-speed) ease;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  pointer-events: none;
  z-index: 0;
}

/*
	Only apply the box-shadow when open to prevent the shadow
  from appearing on the edge of the screen when inactive
 */
.Drawer_drawerContainer__YqgYo {
  --transition-speed: 0.3s;
}
.Drawer_drawerContainer__YqgYo.Drawer_in__Dn\\+-X.Drawer_open__5OT\\+F .Drawer_left__fpsIh {
  transform: translateX(0);
}
.Drawer_drawerContainer__YqgYo.Drawer_in__Dn\\+-X.Drawer_open__5OT\\+F .Drawer_right__e31w9 {
  transform: translateX(0);
}
.Drawer_drawerContainer__YqgYo.Drawer_in__Dn\\+-X.Drawer_open__5OT\\+F .Drawer_backdrop__\\+Jv48 {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
  z-index: 99999;
}
.Drawer_drawerContainer__YqgYo.Drawer_in__Dn\\+-X.Drawer_open__5OT\\+F .Drawer_drawer__rp9rX {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/_common/components/Drawer/Drawer.module.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAIA;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,uCAAA;EACA,kDAAA;EACA,eCoBiB;EDnBjB,WAAA;EACA,gBAAA;AAHF;AAKE;EACE,MAAA;EACA,OAAA;EACA,4BAAA;AAHJ;AAME;EACE,MAAA;EACA,QAAA;EACA,2BAAA;AAJJ;;AAQA;EACE,kBAAA;EACA,UAAA;EACA,8BAAA;EACA,yFAAA;EAEA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,oBAAA;EACA,UAAA;AANF;;AASA;;;EAAA;AAIA;EACE,wBAAA;AANF;AAUM;EACE,wBAAA;AARR;AAWM;EACE,wBAAA;AATR;AAYM;EACE,mBAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;AAVR;AAaM;EACE,uCAAA;AAXR","sourcesContent":["@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n@import '@common/scss/_media';\n\n.drawer {\n  height: 100%;\n  overflow: auto;\n  position: fixed;\n  box-shadow: 0 0 15px rgb(0 0 0 / 0.5);\n  transition: transform var(--transition-speed) ease;\n  z-index: $top-most-z-index;\n  width: 100%;\n  max-width: 320px;\n\n  &.left {\n    top: 0;\n    left: 0;\n    transform: translateX(-100%);\n  }\n\n  &.right {\n    top: 0;\n    right: 0;\n    transform: translateX(100%);\n  }\n}\n\n.backdrop {\n  visibility: hidden;\n  opacity: 0;\n  background: rgb(0 0 0 / 0.5);\n  transition: opacity var(--transition-speed) ease,\n    visibility var(--transition-speed) ease;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: fixed;\n  pointer-events: none;\n  z-index: 0;\n}\n\n/*\n\tOnly apply the box-shadow when open to prevent the shadow\n  from appearing on the edge of the screen when inactive\n */\n.drawerContainer {\n  --transition-speed: 0.3s;\n\n  &.in {\n    &.open {\n      & .left {\n        transform: translateX(0);\n      }\n\n      & .right {\n        transform: translateX(0);\n      }\n\n      & .backdrop {\n        visibility: visible;\n        opacity: 1;\n        pointer-events: auto;\n        z-index: $top-most-z-index - 1;\n      }\n\n      & .drawer {\n        box-shadow: 0 0 15px rgb(0 0 0 / 0.5);\n      }\n    }\n  }\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer": `Drawer_drawer__rp9rX`,
	"left": `Drawer_left__fpsIh`,
	"right": `Drawer_right__e31w9`,
	"backdrop": `Drawer_backdrop__+Jv48`,
	"drawerContainer": `Drawer_drawerContainer__YqgYo`,
	"in": `Drawer_in__Dn+-X`,
	"open": `Drawer_open__5OT+F`
};
export default ___CSS_LOADER_EXPORT___;
